(function() {
  'use strict';

  angular.module('app').controller('FuelRoutesController', FuelRoutesController);

  FuelRoutesController.$inject = [
    '$rootScope',
    '$scope',
    '$routeParams',
    '$location',
    '$timeout',
    '$filter',
    '$translate',
    'blockUI',
    'd3Service',
    '$uibModal',
    'FuelService',
    'SelectService',
    'POSService',
    'TerminalService',
    'NotifyService',
    'uiGmapGoogleMapApi',
    'LANGS'
  ];

  function FuelRoutesController(
      $rootScope,
      $scope,
      $routeParams,
      $location,
      $timeout,
      $filter,
      $translate,
      blockUI,
      d3Service,
      $uibModal,
      FuelService,
      SelectService,
      POSService,
      TerminalService,
      NotifyService,
      GoogleMapApi,
      LANGS
  ) {
    $scope.isPageMode = isPageMode;
    $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
    $scope.filterHelper = {};

    $scope.multilang = MultilanguageHelper();
    $scope.initLocaleStrings = initLocaleStrings;

    $scope.getFiltersList = SelectService.getLPRList;

    $scope.controller;

    var maxRangeMonthsInMaps = 1;
    $scope.controllerMap = {
      openedDateFrom: false,
      openedDateTo: false,
      //minDate: moment().add(-1 * maxRangeMonthsInMaps, 'months').startOf('day').utc().toDate(),
      maxDate: moment().endOf('day').utc().toDate(),
      params: {
        date_from: moment().startOf('day').utc().toDate(),
        date_to: moment().endOf('day').utc().toDate()
      },
      polys: {},
      points: {},
      pointsEvents: {
        click: function(marker, eventName, point, arg) {
          $scope.showHistory(point);
        }
      },
      markerWindow: {
        closeClick: function() {
          this.show = false;
        },
        coords: {
          latitude: 53,
          longitude: 20
        },
        options: {},
        show: false,
        windowParams: {
          TankMeasurements: function() {
            return $scope.controllerMap.markerWindow.TankMeasurements;
          },
          coords: function() {
            return $scope.controllerMap.markerWindow.coords;
          }
        },
        TankMeasurements: []
      }
    };

    $scope.controllersList;

    $scope.controllerListMap = {
      points: []
    };
    $scope.data = {
      // loyaltyId: null,
      loyaltiesList: [],
      showDisabledItems: false,
      posList: [],
      terminalList: [],
      pagerLengths: [10, 20, 50, 100, 200],
      pagerCount: 20,
      pagerPage: 1,
      pagerTotalRowsCount: 0
    };

    var block_controllers_list = blockUI.instances.get('controllers_list');

    $scope.map = {
      center: {
        latitude: 45,
        longitude: -73
      },
      pan: true,
      zoom: 22,
      refresh: false,
      options: {
        overviewMapControl: true,
        overviewMapControlOptions: {opened: true},
        streetViewControl: false,
        scaleControl: true,
        minZoom: 4,
        maxZoom: 20
      },
      events: {},
      bounds: {},
      polys: [],
      draw: undefined
    };
    $scope.getPages = getTotalPaginatedPages;
    $scope.pageChange = function() {

    };
    $scope.onCountChange = function(count) {
      $scope.data.pagerPage = 1;
      $scope.data.pagerCount = count;
    };
    $scope.paginateFilter = function(value) {
      if (!value) return;
      var begin, end, index;
      begin = ($scope.data.pagerPage - 1) * $scope.data.pagerCount;
      end = begin + $scope.data.pagerCount;
      index = $scope.controllerMap.points.indexOf(value);
      return (begin <= index && index < end);
    };

    function isPageMode(mode) {
      return mode === $scope._pageMode;
    }

    /**
     * Check parameter 'mode' in route ../client-accounts/{mode}
     */
    function isRouteMode(mode) {
      return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
    }

    /**
     * Initialize page mode by url
     */
    function initPageMode() {
      $scope._pageMode = 'show';
      //  $scope._pageMode = 'dashboard';
      if (isRouteMode('edit')) {
        $scope._pageMode = ($routeParams.hasOwnProperty('loyalty_id') && $routeParams.hasOwnProperty('controller_id')) ? 'edit' : 'show';
      } else if (isRouteMode('create')) {
        $scope._pageMode = 'create';
      } else if (isRouteMode('dashboard')) {
        $scope._pageMode = 'dashboard';
      }
    }

    /**
     * Initialize controller
     */
    function initControllerPage() {

      $scope.multilang.initLangs(LANGS, $rootScope.LANG);
      initPageMode();

    }

    // *********************************************************************************************
    //  SHOW PART
    // *********************************************************************************************
    /**
     * Prepare data for display page in mode 'show'
     */
    function _doShow() {
      // сначало получить список лояльностей
      loadControllers();
    }

    function loadControllers() {

      block_controllers_list.start();
      var params = {};
      FuelService.getControllerList($scope.filterHelper.id, params, function(success, data) {
        if (success) {
          var controllerListPoints = [];
          $scope.controllersList = data.map(function(item, index) {
            item.allAlarms = [];
            if (item.actual_gps_data && (item.active == 1 || ($scope.data.showDisabledItems && item.active == 0))) {
              if (item.actual_gps_data.latitude && item.actual_gps_data.longitude) {
                controllerListPoints.push({
                  latitude: item.actual_gps_data.latitude,
                  longitude: item.actual_gps_data.longitude,
                  options: {
                    label: {
                      text: (index + 1).toString(),
                      color: '#FFF',
                      fontWeight: 'both'
                    }
                  },
                  events: {
                    click: function(point) {
                      $scope.selectController(item);
                    }
                  },
                  id: item.id
                });
              }
            }
            return item;
          });
          $scope.controllerListMap.points = controllerListPoints;

          if ($routeParams['controllerId']) {
            var controller = $scope.controllersList.find(function(item) {
              return item.id === $routeParams['controllerId'];
            });
            if (controller) {
              // if (!controller.active) {
              //     $scope.data.showDisabledItems = true;
              // }
              $scope.selectController(controller);
            }
          }
        }
        block_controllers_list.stop();
      });
    }

    $scope.showHistory = function(row) {
      $scope.controllerMap.markerWindow.TankMeasurements = [];
      $scope.controllerMap.markerWindow.coords = row;

      $scope.map.center = {
        latitude: row.latitude,
        longitude: row.longitude
      };

      var paramsTankMeasurementsDate = dateFieldsFormat({
        date: row.processed
      }, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]');
      FuelService.getTankMeasurementsDate($scope.controller.loyalty_id, $scope.controller.id, paramsTankMeasurementsDate,
          function(success, data) {
            $scope.controllerMap.markerWindow.TankMeasurements = data;
            $scope.controllerMap.markerWindow.show = true;
            //   $scope.controllerMap.markerWindow.data = data;
          });

      //  $('html,body').animate({scrollTop: angular.element(tf).offset().top - 200}, 'fast');

    };

    $scope.onSelectFilter = function(id, item) {
      loadControllers();
    };

    $scope.onChangeShowOnlyActive = function() {
      loadControllers();
    };
    $scope.selectController = function(controller) {
      if ($scope.controller && controller && $scope.controller.id == controller.id) {
        return;
      }
      block_controllers_list.start();
      $scope.controllerMap.markerWindow.show = false;
      $scope.controller = controller;
      if (controller && $routeParams['controllerId'] !== controller.id) {
        $location.search('controllerId', controller.id);
      } else if (!controller) {
        $location.search('controllerId', null);
      }

      if (controller) {
        buildControllerMaps(controller).then(function() {
          block_controllers_list.stop();
          $scope.$digest();
        });
      } else {
        block_controllers_list.stop();
      }

    };
    $scope.filterDateRangeApply = function() {
      block_controllers_list.start();
      $scope.controllerMap.markerWindow.show = false;
      buildControllerMaps().then(function() {
        $timeout(function() {
          block_controllers_list.stop();
        }, 1000);
      });
    };

    function buildControllerMaps(controller) {
      return new Promise(function(resolve) {

        var controller = controller || $scope.controller;
        $scope.controllerMap.points = [];
        $scope.controllerMap.polys = [];
        // $scope.controllerMap.points = [];
        var requestData = [];

        function requestTankMeasurements(paramsTankMeasurements, loyalty_id, controller_id, callback) {
          var params = angular.copy(paramsTankMeasurements);

          FuelService.getGPSRoute(
              loyalty_id,
              controller_id,
              params,
              function(success, data) {
                if (success) {
                  callback(data.data, data.summary.total_rows_count);

                  // requestData = requestData.concat(data.data);
                  // if (data.data.length >= paramsTankMeasurements.count) {
                  //     paramsTankMeasurements.page += 1;
                  //     requestTankMeasurements(paramsTankMeasurements, loyalty_id, controller_id, callback)
                  // } else {
                  //     callback(requestData);
                  // }
                } else {
                  callback(requestData);
                }
              });

        }

        var paramsControllerMaps = angular.copy($scope.controllerMap.params);
        paramsControllerMaps = dateFieldsFormat(paramsControllerMaps, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]');

        requestTankMeasurements(paramsControllerMaps, controller.loyalty_id, controller.id, function(data, pagerTotalRowsCount) {

          var points = data.filter(function(item) {
            return item.latitude && item.longitude;
          });

          $scope.data.pagerPage = 1;
          $scope.data.pagerTotalRowsCount = pagerTotalRowsCount;

          if (points.length > 0) {
            points = points.map(function(item, index) {
              var point = {
                id: index, //moment(item.processed).toString(),
                date: moment(item.processed).toDate(),
                latitude: item.latitude,
                longitude: item.longitude,
                data: item
              };

              if (!!item.metadata && !!item.metadata.stop_point && !!item.metadata.stop_data) {
                point.icon = {
                  url: 'assets/img/park_hist_marker.gif',
                  size: new google.maps.Size(23, 23),
                  anchor: new google.maps.Point(12, 12)
                };
              } else {
                point.icon = {
                  path: google.maps.SymbolPath.CIRCLE,
                  scale: 4,
                  strokeColor: '#6060FB',
                  fillColor: '#6060FB'
                };
              }
              return point;
            });

            $scope.controllerMap.polys = [
              {
                id: 1,
                path: points,
                stroke: {
                  color: '#6060FB',
                  opacity: 0.6,
                  weight: 2
                },
                fill: {
                  color: '#33CCCC',
                  opacity: 0.8
                },
                icons: [
                  {
                    icon: {
                      //   path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
                      path: google.maps.SymbolPath.FORWARD_OPEN_ARROW
                    },
                    offset: '100%',
                    repeat: '30px'
                    // offset: '25px',
                    // repeat: '50px'
                  }
                ],
                editable: false,
                draggable: false,
                geodesic: true,
                visible: true
              }
            ];

          }

          $scope.controllerMap.points = points;
          resolve();
          // $scope.controllerMaps.points = points;
          // $scope.controllerMaps.data = data;

        });
      });
    }

    $rootScope.$watch('LOYALTIES', function(newValue, oldValue) {
      if (newValue && newValue.length > 0) {
        $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

        if ($rootScope.ENV.filters && $rootScope.ENV.filters.categories_list && $rootScope.ENV.filters.categories_list.loyalty_id) {
          $scope.filterHelper.id = $rootScope.ENV.filters.categories_list.loyalty_id;
        }

        if (!$scope.filterHelper.id) {

          $scope.filterHelper.id = getFirstActive($scope.data.loyaltiesList).id;
        }

        _doShow();

      }
    });

    //
    $scope.$watch('filterHelper.id', function(newValue, oldValue, scope) {
      if (newValue && newValue !== oldValue) {

        loadControllers();
        //if ($scope._pageMode === 'show') {
        // _doShow();
        $rootScope.ENV.filters.categories_list = {
          loyalty_id: newValue
        };
        $rootScope.storeENV();
        //}
      }
    });

    $scope.getLoyaltiesList = SelectService.getLoyaltiesList;

    function initLocaleStrings(goods_category) {
      $scope.multilang.initStrings(goods_category, ['public_title']);
    }

    /**
     * Event receive when change editing language
     */
    $scope.onChangeLanguage = function(new_lang) {
      $scope.multilang.selected(new_lang);
    };

    $scope.onDataExport = function(format) {
      var params = angular.copy($scope.controllerMap.params);

      params = dateFieldsFormat(params, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', false);
      params = cleanRequestData(params);
      var file_name = $rootScope.ENV.business.code
          + '_routes_'
          + moment(params.date_from).format('YYYY-MM-DD_HH:mm:ss')
          + '_' + moment(params.date_to).format('YYYY-MM-DD_HH:mm:ss');
      var export_data = angular.copy($scope.controllerMap.points.map(function(point) {
        return point.data;
      }));
      export_data.forEach(function(row) {
        row.live = $filter('translate')(row.live ? 'Controller live gps' : 'Controller live manual');
        row.processed = moment(row.processed).format('YYYY-MM-DD HH:mm:ss');

        delete row.metadata;
        delete row.valid;

        Object.keys(row).forEach(function(key) {

          row[key] = row[key] === '' ? '-' : row[key];

          // Заменяем значения ключей на переведенные
          row[$filter('translate')('Controller ' + key)] = row[key];
          delete row[key];
        });
      });
      switch (format) {
        case 'XLSX':
          alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [export_data]);
          break;
        case 'XLS':
          alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [export_data]);
          break;
        case 'CSV':
          alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [export_data]);
          break;
      }
    };
    initControllerPage();

    $scope.$watch('controllerMap.params.date_to', function(newValue, oldValue) {
      if (!!newValue) {
        if ((moment(newValue).diff($scope.controllerMap.params.date_from, 'months', true)) > maxRangeMonthsInMaps) {
          $scope.controllerMap.params.date_from = moment($scope.controllerMap.params.date_to).
              subtract(maxRangeMonthsInMaps, 'month').
              utc().
              toDate();
        } else if ((moment(newValue).diff($scope.controllerMap.params.date_from, 'days', true)) < 0) {
          $scope.controllerMap.params.date_from = $scope.controllerMap.params.date_to;
        }
      }
    });
    $scope.$watch('controllerMap.params.date_from', function(newValue, oldValue) {
      if (!!newValue && (moment($scope.controllerMap.params.date_to).diff(newValue, 'months', true)) > maxRangeMonthsInMaps) {
        $scope.controllerMap.params.date_to = moment($scope.controllerMap.params.date_from).
            add(maxRangeMonthsInMaps, 'month').
            utc().
            toDate();
      }
    });
  }
})();
